import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import { themr } from '../react-css-themr'
import { LIST } from '../identifiers'
import { FontIcon } from '../font_icon/FontIcon'
import InjectAvatar from '../avatar/Avatar'
import InjectListItemContent from './ListItemContent'
import InjectListItemActions from './ListItemActions'

const factory = (Avatar, ListItemContent, ListItemActions) => {
  const ListItemLayout = ({
    avatar,
    caption,
    className,
    disabled = false,
    itemContent,
    leftActions,
    leftIcon,
    legend,
    rightActions,
    rightIcon,
    selectable = false,
    theme,
  }) => {
    const combinedClassName = cx(
      theme.item,
      {
        [theme.disabled]: disabled,
        [theme.selectable]: selectable,
      },
      className
    )

    const computedLeftActions = [
      leftIcon && <FontIcon value={leftIcon} key='leftIcon' />,
      avatar && <Avatar image={avatar} key='avatar' />,
      ...leftActions,
    ]

    const computedRightActions = [
      rightIcon && <FontIcon value={rightIcon} key='rightIcon' />,
      ...rightActions,
    ]

    const emptyActions = item => !item[0] && !item[1] && !item[2]

    const content = itemContent || (
      <ListItemContent theme={theme} caption={caption} legend={legend} />
    )

    return (
      <span className={combinedClassName}>
        {!emptyActions(computedLeftActions) > 0 && (
          <ListItemActions type='left' theme={theme}>
            {computedLeftActions}
          </ListItemActions>
        )}
        {content}
        {!emptyActions(computedRightActions) > 0 && (
          <ListItemActions type='right' theme={theme}>
            {computedRightActions}
          </ListItemActions>
        )}
      </span>
    )
  }

  ListItemLayout.propTypes = {
    avatar: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    caption: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    className: PropTypes.string,
    disabled: PropTypes.bool,
    itemContent: PropTypes.element,
    leftActions: PropTypes.arrayOf(PropTypes.node),
    leftIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    legend: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    rightActions: PropTypes.arrayOf(PropTypes.node),
    rightIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    selectable: PropTypes.bool,
    theme: PropTypes.shape({
      disabled: PropTypes.string,
      item: PropTypes.string,
      selectable: PropTypes.string,
    }),
  }

  return ListItemLayout
}

const ListItemLayout = factory(InjectAvatar, InjectListItemContent, InjectListItemActions)
export default themr(LIST)(ListItemLayout)
export { factory as listItemLayoutFactory }
export { ListItemLayout }
